import React from 'react';
import { Link } from 'react-router-dom';
import {
  CLIMATEPLANS_DATA_USE_NOTICE,
  MEMBER_EXPORT_LOCK_MESSAGE,
  MEMBER_EXPORT_LOCK_SUBTEXT,
  MEMBERSHIP_APPLY_PATH,
  SCHEDULE_DEMO_PATH,
} from '../../constants/dataUsePolicy';
import './MemberExportNotice.css';

export interface MemberExportNoticeProps {
  variant?: 'compact' | 'panel';
  showDataUseNotice?: boolean;
  className?: string;
}

export const MemberExportNotice: React.FC<MemberExportNoticeProps> = ({
  variant = 'compact',
  showDataUseNotice = variant === 'panel',
  className = '',
}) => (
  <div
    className={`member-export-notice member-export-notice--${variant} ${className}`.trim()}
    role="note"
    aria-label="Membership export information"
  >
    <p className="member-export-notice__message">{MEMBER_EXPORT_LOCK_MESSAGE}</p>
    <p className="member-export-notice__subtext">{MEMBER_EXPORT_LOCK_SUBTEXT}</p>
    <div className="member-export-notice__actions">
      <Link to={MEMBERSHIP_APPLY_PATH} className="member-export-notice__btn member-export-notice__btn--primary">
        Become a Member
      </Link>
      <Link to={SCHEDULE_DEMO_PATH} className="member-export-notice__btn member-export-notice__btn--primary">
        Schedule a Demo
      </Link>
    </div>
    {showDataUseNotice && (
      <p className="member-export-notice__notice">{CLIMATEPLANS_DATA_USE_NOTICE}</p>
    )}
  </div>
);

export default MemberExportNotice;
